import React, { Component } from 'react';
import GlobalUIContext from '../global-ui-context';

class SiderMenuProvider extends Component {
  state = {
    collapsed: false,
  };

  _toggleMenuCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    return (
      <GlobalUIContext.Provider
        value={{
          siderMenu: {
            state: this.state,
            toggleMenuCollapse: this._toggleMenuCollapse,
          },
        }}
      >
        {this.props.children}
      </GlobalUIContext.Provider>
    );
  }
}

export default SiderMenuProvider;
